// extracted by mini-css-extract-plugin
export default {"animal_view__container":"AnimalView_animal_view__container__gHkvG"};